<div class="files-list" [class.show-border]="showDocumentType">
  <form [formGroup]="form">
    <div
      class="file-list-row"
      *ngFor="
        let uploadedFileControl of uploadedFilesFormArray.controls;
        index as i
      "
      formArrayName="uploadedFiles"
    >
      <ng-container *ngIf="files[i]; let fileObj" [formGroupName]="i">
        <div class="row">
          <div class="col-md">
            <div class="file-info">
              <img src="assets/icons/ic-tick-green@3x.svg" alt="" />
              <div class="name">
                {{ fileObj.file.name }}
                <span *ngIf="fileObj.file.size"
                  >({{ formatBytes(fileObj.file.size) }})</span
                >
              </div>
              <img
                class="delete"
                src="assets/icons/ic-delete@3x.svg"
                alt="delete"
                (click)="deleteFile(i)"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="showDocumentType">
            <div class="field-wrapper document-type-input">
              <label [for]="'typeOfDocument-' + i">
                <span>Type of document</span>
                <input
                  type="text"
                  [id]="'typeOfDocument-' + i"
                  formControlName="documentType"
                  [class.invalid-input]="
                    !uploadedFileControl.get('documentType')?.valid &&
                    uploadedFileControl.get('documentType')?.touched
                  "
                />
              </label>
              <span
                *ngIf="
                  !uploadedFileControl.get('documentType')?.valid &&
                  uploadedFileControl.get('documentType')?.errors?.required &&
                  uploadedFileControl.get('documentType')?.touched
                "
                class="error"
                >Please enter the type of document</span
              >
              <span
                *ngIf="
                  !uploadedFileControl.get('documentType')?.valid &&
                  uploadedFileControl.get('documentType')?.errors?.pattern &&
                  uploadedFileControl.get('documentType')?.touched
                "
                class="error"
                >The following characters are not allowed:
                {{ INVALID_CHARACTERS }}</span
              >
              <span
                *ngIf="
                  !uploadedFileControl.get('documentType')?.valid &&
                  uploadedFileControl.get('documentType')?.errors?.maxlength &&
                  uploadedFileControl.get('documentType')?.touched
                "
                class="error"
              >
                You have exceeded the maximum
                {{ MAX_CHARACTERS }} characters limit
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!--    <div-->
    <!--      *ngIf="uploadedFilesFormArray.errors?.required && form.touched"-->
    <!--      class="error"-->
    <!--    >-->
    <!--      Please upload a file.-->
    <!--    </div>-->
  </form>
</div>
<div
  *ngIf="files.length < maxNoOfUpload"
  class="file-upload"
  appDragAndDrop
  (fileDropped)="handleFileDropped($event)"
>
  <label for="fileDropRef"
    ><input
      type="file"
      #fileDropRef
      id="fileDropRef"
      [multiple]="maxNoOfUpload > 1"
      (change)="handleFileSelected($event)"
    />
    <img src="assets/icons/ic-upload@3x.svg" alt="upload file" />
    <span class="upload-information">PDF, JPEG, PNG, smaller than 5MB</span>
    <span class="upload-instruction" *ngIf="!globals.isMobile"
      >Drag and drop to upload a file, or
      <span class="blue-link">browse</span></span
    >
    <span class="upload-instruction" *ngIf="globals.isMobile"
      >Browse to upload a file</span
    >
  </label>
</div>
